import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PromocionesService } from '../../services/promociones.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';

@Component({
  selector    : 'app-promo-cond-tier-form',
  templateUrl : './promo-cond-tier-form.component.html',
  styleUrls   : ['./promo-cond-tier-form.component.css']
})

export class PromoTierFormComponent implements OnInit {

  agregarFormCondicion!: FormGroup;
  cmbOficinaVenta = [];
  public comboTier: any[];

  @Input()
  set idPromo(id: string) {
    this.agregarFormCondicion.get('id_promo').setValue(id);
  }

  @Input()
  idCondicionInput: string[];

  @Output()
  back = new EventEmitter<void>();

  @Output()
  create = new EventEmitter<any>();

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly promocionesService: PromocionesService,
    private readonly dmaestrosServices : DatosMaestrosService
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    this.cargarListCondicion();
  }

  private buildForm() {
    this.agregarFormCondicion = this.formBuilder.group({
      id_promo: ['', []],
      id_tiers: ['', [Validators.required]]
    })
  }

  cargarListCondicion() {
    //return this.comboTier;    
    this.dmaestrosServices.getAllTiers().subscribe(
      (resp) => {
        if (resp) {
          this.comboTier = resp;
        } else {
          this.comboTier = [];
        }
      },
      (error) => {
        this.comboTier = [];
      }
    );

  }

  accionesCondOficinaVenta(event: string) {
    if (event === 'guardar') {
      this.create.emit(this.agregarFormCondicion.getRawValue());
    } else {
      this.back.emit();
    }
  }

}
